"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInvitationExistsApiResponseSchema = exports.invitationSlotSummarySchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const invitation_1 = require("./invitation");
exports.invitationSlotSummarySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    start: zod_1.z.string().datetime(),
    end: zod_1.z.string().datetime(),
    agendaName: zod_1.z.string(),
    siteName: zod_1.z.string(),
});
exports.getInvitationExistsApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: (0, api_1.apiEntityTypeSchema)('invitations'),
        attributes: zod_1.z.object({
            email: zod_1.z.string().email(),
            type: zod_1.z.enum(invitation_1.invitationTypes),
            metadata: zod_1.z.any().optional(),
            slots: zod_1.z.array(exports.invitationSlotSummarySchema).optional(),
        }),
    }),
});
